import {Injectable} from '@angular/core';
import {EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import {ProductParameterSize} from './model';

export interface ProductParameterSizeState extends EntityState<ProductParameterSize> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'ProductParameterSize' })
export class Store extends EntityStore<ProductParameterSizeState> {

  constructor() {
    super();
  }

}
